import map from 'lodash/map'
import React from 'react'
import { useContext } from '../Context'
import { LinkToProductSearch } from '../../../../components/Links/LinkToProductSearch'
import { useListViewContext } from './Context'

export default function Paging() {
  const listViewContext = useListViewContext()
  const { allFilter, skip, search } = useContext()

  const count = listViewContext?.listResult?.pageInfo?.count ?? 0

  const { pages, totalPages, currentPage } = paginate(count, skip)

  return (
    <nav className="mb-4">
      <ul className="pagination">
        <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
          <LinkToProductSearch skip={currentPage - 1} search={search} {...allFilter} className="page-link">
            Previous
          </LinkToProductSearch>
        </li>

        {map(pages, (item) => (
          <li key={item} className={`page-item ${item === currentPage ? 'active' : ''}`}>
            <LinkToProductSearch skip={item} search={search} {...allFilter} className="page-link">
              {item}
            </LinkToProductSearch>
          </li>
        ))}

        <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
          <LinkToProductSearch skip={currentPage + 1} search={search} {...allFilter} className="page-link">
            Next
          </LinkToProductSearch>
        </li>
      </ul>
    </nav>
  )
}

function paginate(totalItems, currentPage = 1, pageSize = 10, maxPages = 5) {
  // calculate total pages
  const totalPages = Math.ceil(totalItems / pageSize)

  // ensure current page isn't out of range
  if (currentPage < 1) {
    currentPage = 1
  } else if (currentPage > totalPages) {
    currentPage = totalPages
  }

  let startPage, endPage
  if (totalPages <= maxPages) {
    // total pages less than max so show all pages
    startPage = 1
    endPage = totalPages
  } else {
    // total pages more than max so calculate start and end pages
    const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2)
    const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1
    if (currentPage <= maxPagesBeforeCurrentPage) {
      // current page near the start
      startPage = 1
      endPage = maxPages
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // current page near the end
      startPage = totalPages - maxPages + 1
      endPage = totalPages
    } else {
      // current page somewhere in the middle
      startPage = currentPage - maxPagesBeforeCurrentPage
      endPage = currentPage + maxPagesAfterCurrentPage
    }
  }

  // calculate start and end item indexes
  const startIndex = (currentPage - 1) * pageSize
  const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1)

  // create an array of pages to ng-repeat in the pager control
  const pages = Array.from(Array(endPage + 1 - startPage).keys()).map((i) => startPage + i)

  // return object with all pager properties required by the view
  return {
    totalItems,
    currentPage,
    pageSize,
    totalPages,
    startPage,
    endPage,
    startIndex,
    endIndex,
    pages,
  }
}
